module.exports = __webpack_public_path__ + "static/media/06.259dec31.png";